import { useDeviceLayout } from '../../../hooks/useDeviceLayout';
import { useMembersState } from './useMembersState';
import { MembersDesktop } from './MembersDesktop';
import { MembersMobile } from './MembersMobile';

/**
 * 멤버 관리 페이지
 *
 * ResponsivePage 패턴을 적용하여 모바일/데스크톱 레이아웃을 분리합니다.
 */
export default function MembersPage() {
  const layout = useDeviceLayout();
  const { data, modals, handlers } = useMembersState();
  const isMobile = layout === 'phone' || layout === 'fold';

  // 로딩 상태
  if (data.isLoading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-600"></div>
      </div>
    );
  }

  // 레이아웃 선택
  const Layout = isMobile ? MembersMobile : MembersDesktop;

  return <Layout data={data} modals={modals} handlers={handlers} layout={layout} />;
}
